import type { FC } from "react";
import { useMediaQuery } from "react-responsive";

import { useSwiperSlide } from "swiper/react";

import type { ProductGalleryAsset } from "@jti/fe-common";
import { VideoPlayer } from "@jti/ui/components/VideoPlayer";

import { extractVideoMetadata } from "../../utils/extractVideoMetadata/extractVideoMetadata";

type ProductGalleryVideoProps = {
  item: ProductGalleryAsset;
  idx?: number;
  seekLabel?: string;
  volumeLabel?: string;
  playLabel?: string;
  replayLabel?: string;
  muteLabel?: string;
  soundOnLabel?: string;
  showFullscreenLabel?: string;
};

export const ProductGalleryVideo: FC<ProductGalleryVideoProps> = ({
  item,
  seekLabel,
  volumeLabel,
  playLabel,
  replayLabel,
  muteLabel,
  soundOnLabel,
  showFullscreenLabel,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 479 });
  const swiperSlide = useSwiperSlide();

  const { previewPath, path, videoContentDto, autoPlayEnabled } = item;
  const posterUrl = videoContentDto ? path : previewPath;
  const videoUrl = videoContentDto?.videoUrl ? videoContentDto.videoUrl : path;

  const videoMetadata = extractVideoMetadata(videoContentDto);

  const autoplayOnDesktop = (autoPlayEnabled || videoMetadata.autoPlay) && !isMobile;

  if (!videoUrl) {
    return null;
  }

  return (
    <VideoPlayer
      desktopSrc={videoUrl}
      poster={posterUrl}
      autoPlay={autoplayOnDesktop && swiperSlide?.isActive}
      className="carousel__galleryMedia"
      showControls={true}
      loop={autoplayOnDesktop}
      showFullscreen={true}
      keepOriginalAspectRatio={true}
      shouldStopVideo={swiperSlide && !swiperSlide.isActive}
      playLabel={playLabel}
      replayLabel={replayLabel}
      muteLabel={muteLabel}
      soundOnLabel={soundOnLabel}
      seekLabel={seekLabel}
      volumeLabel={volumeLabel}
      showFullscreenLabel={showFullscreenLabel}
    />
  );
};
